const CACHE_PREFIX = 'radio_scraper_cache_';

/**
 * Format a Date object to YYYY-MM-DD
 */
function getTodayDateStr() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * Retrieve cached show episodes for a given date string (YYYY-MM-DD or YYYY/MM/DD)
 */
export function getCachedDate(dateStr) {
  try {
    const key = CACHE_PREFIX + dateStr.replace(/\//g, '-');
    const today = getTodayDateStr();
    const isToday = dateStr.replace(/\//g, '-') === today;

    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const entry = JSON.parse(raw);

    // If it's today's date, expire cache after 15 minutes to allow new episodes to appear
    if (isToday) {
      const fifteenMinutes = 15 * 60 * 1000;
      if (Date.now() - entry.timestamp > fifteenMinutes) {
        localStorage.removeItem(key);
        return null;
      }
    }

    return entry.data;
  } catch (err) {
    console.warn('Failed to read from cache:', err);
    return null;
  }
}

/**
 * Save show episodes for a given date string
 */
export function setCachedDate(dateStr, data) {
  try {
    if (!data || !Array.isArray(data)) return;
    const key = CACHE_PREFIX + dateStr.replace(/\//g, '-');
    const entry = {
      timestamp: Date.now(),
      data
    };
    localStorage.setItem(key, JSON.stringify(entry));
  } catch (err) {
    console.warn('Failed to write to cache:', err);
  }
}

/**
 * Clear all cached radio shows
 */
export function clearAllCache() {
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(CACHE_PREFIX)) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach(k => localStorage.removeItem(k));
    return keysToRemove.length;
  } catch (err) {
    console.warn('Failed to clear cache:', err);
    return 0;
  }
}

/**
 * Get statistics about the cached dates
 */
export function getCacheStats() {
  try {
    let count = 0;
    let bytes = 0;
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(CACHE_PREFIX)) {
        count++;
        const val = localStorage.getItem(k);
        bytes += (k.length + (val ? val.length : 0)) * 2; // rough UTF-16 bytes
      }
    }
    return {
      count,
      sizeKb: Math.round(bytes / 1024)
    };
  } catch (err) {
    return { count: 0, sizeKb: 0 };
  }
}
